import { routes } from "../../../routes/routes";
import { findCurrectPermission } from "../../../helpers/roles-and-permissions";
import { enums } from "../../../enums/Enums";
const encryptedUserId = localStorage.getItem("encryptedUserId");
const storedUser = localStorage.getItem("user");
const UserName = JSON.parse(storedUser);
// const name = username.name ? JSON.parse(username.name) : null;  

//  console.log(username.name)
const Menuitems = [
  {
    navlabel: true,
    subheader: "GENERAL",
    icon: "mdi mdi-dots-horizontal",
    href: routes?.dashboard?.match,
    display: true,
  },
  {
    title: "Modern",
    icon: "hard-drive",
    href: "/dashboards/dashboard3",
    display: false,
  },
  {
    title: "Dashboard",
    icon: "pie-chart",
    href: routes?.dashboard?.match,
    display: true,
  },
  {
    title: "eCommerce",
    icon: "shopping-bag",
    href: "/dashboards/dashboard2",
  },

  {
    title: "Leave - Pass Mgt.",
    icon: "calendar",
    href: "/time-attendance",
    collapse: true,
    display:
      findCurrectPermission(enums.UserPermissionNames.T_A_IN_OUT_FOR_LUNCH) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_IN_OUT_FOR_BUSINESS
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_IN_OUT_FOR_PERSONAL_BUSINESS
        ) ||
        findCurrectPermission(enums.UserPermissionNames.T_A_MY_MISSING_PUNCHES) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_WHO_IS_IN_THE_BUILDING
        ) ||
        findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_APPROVE) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_HR_APPROVAL) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_REVIEW_YTD_STATUS) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_SHOW_ALL_DEPT) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_SHOW_ALL_FUTURE_DEPT)
        ? true
        : false,
    children: [
      {
        title: "In/Out For Lunch",
        icon: "list",
        href: routes?.attendanceForLunch?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.T_A_IN_OUT_FOR_LUNCH
        )
          ? true
          : false,
      },
      {
        title: "In/ Out For Business",
        icon: "list",
        href: routes?.attendanceForBusiness?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.T_A_IN_OUT_FOR_BUSINESS
        )
          ? true
          : false,
      },
      {
        title: "In/Out For Personal Business",
        icon: "list",
        href: routes?.attendanceForPersonalBusiness?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.T_A_IN_OUT_FOR_PERSONAL_BUSINESS
        )
          ? true
          : false,
      },

      {
        title: "My Missing Punches",
        icon: "list",
        href: routes?.missingPunch?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.T_A_MY_MISSING_PUNCHES
        )
          ? true
          : false,
      },
      {
        title: "My Time Punch Records",
        icon: "list",
        href: `https://asai.sswhite.co/datafromdeviceemployee.aspx?userloginID=${localStorage.getItem("encryptedUserId")}`,
        display: findCurrectPermission(
          enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
        )
          ? true
          : false,
      },
      {
        title: "Who's In The Building",
        icon: "list",
        href: routes?.building?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.T_A_WHO_IS_IN_THE_BUILDING
        )
          ? true
          : false,
      },
      {
        title: "New Leave Request",
        icon: "list",
        href: routes?.ftoCreate?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST
        )
          ? true
          : false,
      },
      {
        title: "Approve FTO",
        icon: "list",
        href: routes?.ftoApprove?.match,
        display: findCurrectPermission(enums.UserPermissionNames.FTO_APPROVE)
          ? true
          : false,
      },

      {
        title: "FTO's HR Approval",
        icon: "list",
        href: routes?.ftoHrApprove?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.FTO_HR_APPROVAL
        )
          ? true
          : false,
      },
      {
        title: "Review YTD FTO Status",
        icon: "list",
        href: routes?.ftoReviewYTD?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.FTO_REVIEW_YTD_STATUS
        )
          ? true
          : false,
      },

      {
        title: "Show All FTO's Of My Dept.",
        icon: "list",
        href: routes?.ftoAllDepartment?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.FTO_SHOW_ALL_DEPT
        )
          ? true
          : false,
      },
      {
        title: "Show All Future FTO's Of My Dept.",
        icon: "list",
        href: routes?.ftoFutureDepartment?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.FTO_SHOW_ALL_FUTURE_DEPT
        )
          ? true
          : false,
      },
      {
        title: "Visitors Pass",
        icon: "list",
        href: routes?.allvisitorlist?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.FTO_Addvisitor
        )
          ? true
          : false,
      },
    ],
  },
  // {
  //   title: "Gatepass",
  //   icon: "pie-chart",    
  //   href: `http://localhost:3001/Login?username=${username.name}`,
  //   display: findCurrectPermission(
  //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //       )
  //         ? true
  //         : false,

  // },


  {
    title: "Expense Purchase Order",
    icon: "file-text",
    href: "/epo",
    collapse: true,
    display:
      findCurrectPermission(enums.UserPermissionNames.EPO_Manage) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MPC_EPO_VIEWER) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MPC_VOTE_FOR_EPO) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MY_EPOS) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_REVIEW_YTD_STATUS) ||
        findCurrectPermission(
          enums.UserPermissionNames.EPO_VIEW_MY_SUB_ORDINATES_EPO
        ) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MY_APPROVAL_FOR_EPO)
        ? true
        : false,
    children: [
      {
        title: "Manage EPO",
        icon: "list",
        href: routes?.epoCreate?.match,
        display: findCurrectPermission(enums.UserPermissionNames.EPO_Manage)
          ? true
          : false,
      },
      // {
      //   title: "Edit EPO",
      //   icon: "list",
      //   href: routes?.epoEdit?.match,
      // },
      {
        title: "MPC EPO Viewer",
        icon: "list",
        href: routes?.epoDetail?.match,
        subChild: {
          href: [routes?.epoView?.matchSidebar.find((x) => x).url1],
        },
        display: findCurrectPermission(
          enums.UserPermissionNames.EPO_MPC_EPO_VIEWER
        )
          ? true
          : false,
      },
      {
        title: "MPC vote for EPO",
        icon: "list",
        isCount: true,
        href: routes?.epoVote?.match,
        subChild: {
          href: [routes?.epoView?.matchSidebar.find((x) => x).url2],
        },
        display: findCurrectPermission(
          enums.UserPermissionNames.EPO_MPC_VOTE_FOR_EPO
        )
          ? true
          : false,
      },
      {
        title: "My EPOs",
        icon: "list",
        href: routes?.epoList?.match,
        subChild: {
          href: [routes?.epoView?.matchSidebar.find((x) => x).url3],
        },
        display: findCurrectPermission(enums.UserPermissionNames.EPO_MY_EPOS)
          ? true
          : false,
      },
      // {
      //   title: "EPO's not ready for payment",
      //   icon: "list",
      //   href: routes?.epoPayment?.match,
      // },
      {
        title: "View My Subordinate's EPO",
        icon: "list",
        href: routes?.epoSubordinate?.match,
        subChild: {
          href: [routes?.epoView?.matchSidebar.find((x) => x).url4],
        },
        display: findCurrectPermission(
          enums.UserPermissionNames.EPO_VIEW_MY_SUB_ORDINATES_EPO
        )
          ? true
          : false,
      },
      {
        title: "My Approval for EPO",
        icon: "list",
        islength: true,
        isCountMyApproval: true,
        href: routes?.epoApproval?.match,
        subChild: {
          href: [routes?.epoView?.matchSidebar.find((x) => x).url5],
        },
        display: findCurrectPermission(
          enums.UserPermissionNames.EPO_MY_APPROVAL_FOR_EPO
        )
          ? true
          : false,
      },
    ],
  },

  {
    title: "Document Management System",
    icon: "layout",
    href: "/document-management",
    collapse: true,
    display:
      findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_ECN
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_FCD
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_LIT
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_SOP
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_WI
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_AWAITING_MY_APPROVAL
        )
        ? true
        : false,
    children: [
      {
        title: "All Documents",
        icon: "list",
        href: routes?.allDocuments?.match,
        display: findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL)
          ? true
          : false,
      },
      {
        title: "Create New ECN",
        icon: "list",
        href: routes?.createECN?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_ECN
        )
          ? true
          : false,
      },
      {
        title: "Create New FCD",
        icon: "list",
        href: routes?.createFCD?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_FCD
        )
          ? true
          : false,
      },
      {
        title: "Create New LIT",
        icon: "list",
        href: routes?.createLIT?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_LIT
        )
          ? true
          : false,
      },
      {
        title: "Create New SOP",
        icon: "list",
        href: routes?.createSOP?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_SOP
        )
          ? true
          : false,
      },
      {
        title: "Create New WI",
        icon: "list",
        href: routes?.createWI?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_WI
        )
          ? true
          : false,
      },
      {
        title: "Document Awaiting My Approval",
        icon: "list",
        isTotal: true,
        href: routes?.documentMyApproval?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_AWAITING_MY_APPROVAL
        )
          ? true
          : false,
      },
    ],
  },
  {
    title: "HR Management",
    icon: "user",
    href: "/hr",
    collapse: true,
    display:
      // findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process) ||
      findCurrectPermission(enums.UserPermissionNames.HR_All_Recruitees) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Email_For_Training) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Employee_Of_The_Month_Nomination) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Lets_Know_Each_other_details) ||
        findCurrectPermission(
          enums.UserPermissionNames.HR_Welcome_New_Employee
        ) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Gate_Pass) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Leave_Sheet) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Training) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Training_Courses) ||
        findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ||
        findCurrectPermission(enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT
        ) || findCurrectPermission(enums.UserPermissionNames.HR_AddQuestion) ||
        findCurrectPermission(enums.UserPermissionNames.HR_ALLQuestion) ||
        findCurrectPermission(enums.UserPermissionNames.HR_GetCandidateResume) ||
        findCurrectPermission(enums.UserPermissionNames.HR_AddCandidateResume)


        ? true
        : false,
    children: [
      {
        title: "Add Employee",
        icon: "list",
        href: routes?.addemployee?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE
        )
          ? true
          : false,
      },
      {
        title: "Employees",
        icon: "list",
        href: routes?.limitEmployees.match,
        subChild: {
          href: [
            routes?.editEmployee?.matchSidebar,
            routes?.employeeView?.matchSidebar,
          ],
        },
        display: findCurrectPermission(
          enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT
        )
          ? true
          : false,
      },
      {
        title: "Pre-Recruitment Process",
        icon: "list",
        href: routes?.hrInterviewCreate?.match,
        display: findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process)
          ? true
          : false,
      },
      {
        title: "Candidates",
        icon: "list",
        href: routes?.allRecruitee?.match,
        display: findCurrectPermission(enums.UserPermissionNames.HR_All_Recruitees)
          ? true
          : false,
      },
      {
        title: "Employee Of The Month Nomination",
        icon: "list",
        href: routes?.allNominee?.match,
        subChild: {
          href: [
            routes?.EmployeeOfTheMonthNomination?.match,
            routes?.nomineeView?.matchSidebar,
          ],
        },
        display: findCurrectPermission(enums.UserPermissionNames.HR_Employee_Of_The_Month_Nomination)
          ? true
          : false,
      },
      {
        title: "Welcome New Employee",
        icon: "list",
        href: routes?.welcomeNewEmpl?.match,
        display: findCurrectPermission(enums.UserPermissionNames.HR_Welcome_New_Employee)
          ? true
          : false,
      },
      {
        title: "Let's Know Each other details",
        icon: "list",
        href: routes?.allLetsKnowEachOtherDetails?.match,
        subChild: {
          href: [
            routes?.addLetsKnowEachOtherDetails?.match,
            routes?.letsKnowEachotherDetailsView?.matchSidebar,
          ],
        },
        display: findCurrectPermission(enums.UserPermissionNames.HR_Lets_Know_Each_other_details)
          ? true
          : false,
      },
      // {
      //   title: "Gate Pass",
      //   icon: "list",
      //   href: routes?.allGatePass?.match,
      //   subChild: {
      //     href: [
      //       routes?.addGatePass?.match,
      //       routes?.gatePassView?.matchSidebar,
      //     ],
      //   },
      //   display: findCurrectPermission(enums.UserPermissionNames.HR_Gate_Pass)
      //     ? true
      //     : false,
      // },
      {
        title: "Leave Sheet",
        icon: "list",
        href: routes?.allLeaveSheet?.match,
        subChild: {
          href: [
            routes?.addLeaveSheet?.match,
            routes?.viewLeaveSheet?.matchSidebar,
          ],
        },
        display: findCurrectPermission(enums.UserPermissionNames.HR_Leave_Sheet)
          ? true
          : false,
      },
      {
        title: "Training Courses",
        icon: "list",
        href: routes?.allCourseList.match,
        subChild: {
          href: [
            routes?.addCourseForm?.match,
            routes?.viewCourseDetails?.matchSidebar,
          ],
        },
        display: findCurrectPermission(enums.UserPermissionNames.HR_Training_Courses)
          ? true
          : false,
      },
      {
        title: "Training",
        icon: "list",
        href: routes?.allTrainingList?.match,
        subChild: {
          href: [
            routes?.addTrainingSheetForm?.match,
            routes?.editTraining?.matchSidebar,
            routes?.viewTraining?.matchSidebar,
          ],
        },
        display: findCurrectPermission(enums.UserPermissionNames.HR_Training)
          ? true
          : false,
      },
      {
        title: "Email For Training",
        icon: "list",
        href: routes?.emailForTraining?.match,
        display: findCurrectPermission(enums.UserPermissionNames.HR_Email_For_Training)
          ? true
          : false,
      },
      {
        title: "Add Question",
        icon: "list",
        href: routes?.addQuestion?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.HR_AddQuestion
        )
          ? true
          : false,
      },
      {
        title: "All Question",
        icon: "list",
        href: routes?.allQuestionlist?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.EPO_MPC_EPO_VIEWER
        )
          ? true
          : false,
      },
      // {
      //   title: "Add Candidate CV",
      //   icon: "list",
      //   href: routes?.addCandidateCV?.match,
      //   display: findCurrectPermission(
      //     enums.UserPermissionNames.HR_AddCandidateResume
      //   )
      //     ? true
      //     : false,
      // },
      {
        title: "ALL Candidate CV",
        icon: "list",
        href: routes?.getCandidateCV?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.EPO_MPC_EPO_VIEWER
        )
          ? true
          : false,
      },
      // no  need to use currently
      // {
      //   title: "Training Module",
      //   icon: "list",
      //   href: routes?.addTrainingSheetForm?.match,
      //   display: findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL)
      //     ? true
      //     : false,
      // },
    ],
  },

  //Bhargav

  {
    title: "Interview",
    icon: "user",
    href: routes?.interviewEvalutionForm?.match,
    display:
      findCurrectPermission(enums.UserPermissionNames.HR_Genral_Evalution)
        ? true
        : false,
    children: [
      {
        title: "Interview Form",
        icon: "list",
        href: routes?.hrInterviewCreate?.match,
        display: findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process)
          ? true
          : false,
      },
    ],
  },

  {
    title: "Interview Evalution",
    icon: "user",
    href: routes?.interviewEvaluation?.match,
    collapse: true,
    display:
      findCurrectPermission(enums.UserPermissionNames.HR_Genral_Evalution)
        ? true
        : false,
    children: [
      {
        title: "EvalutionForm",
        icon: "list",
        href: routes?.interviewEvaluationForm?.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.HR_Genral_Evalution
        )
          ? true
          : false,

      },
      {
        title: "Evaluation interviewee",
        icon: "list",
        href: routes?.allEvalutionCandidate?.match,
        display: findCurrectPermission(enums.UserPermissionNames.HR_Genral_Evalution)
          ? true
          : false,
      }


    ],
  },
  //  {
  //   title:  "Interview Process",
  //   icon: "user",
  //     href: routes?.interviewEvaluation?.match,
  //   collapse: true,
  //   display:
  //     findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process)  


  //       ? true
  //       : false,
  //   children: [
  //       {
  //       title: "Pre-Recruitment Process",
  //       icon: "list",
  //       href: routes?.hrInterviewCreate?.match,
  //        display: findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process)
  //         ? true
  //         : false,
  //     }



  //   ],
  // },
  //  {
  //     title:  "Interview Evalution Process",
  //     icon: "user",
  //       href: routes?.interviewEvaluation?.match,
  //     collapse: true,
  //     display:
  //       findCurrectPermission(enums.UserPermissionNames.HR_Genral_Evalution)  


  //         ? true
  //         : false,
  //     children: [

  //       {
  //         title: "EvalutionForm",
  //         icon: "list",
  //         href: routes?.interviewEvaluationForm?.match,
  //         display: findCurrectPermission(
  //           enums.UserPermissionNames.HR_Genral_Evalution
  //         )
  //           ? true
  //           : false,

  //       } 


  //     ],
  //   },


  ////

  {
    title: "Change Request",
    icon: "file-text",
    href: "/cr",
    collapse: true,
    display:
      findCurrectPermission(enums.UserPermissionNames.EPO_Manage) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MPC_EPO_VIEWER) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MPC_VOTE_FOR_EPO) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MY_EPOS) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_REVIEW_YTD_STATUS) ||
        findCurrectPermission(
          enums.UserPermissionNames.EPO_VIEW_MY_SUB_ORDINATES_EPO
        ) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MY_APPROVAL_FOR_EPO)
        ? true
        : false,
    children: [
      {
        title: "New Change Request",
        icon: "list",
        href: routes?.crCreate?.match,
        display: findCurrectPermission(enums.UserPermissionNames.EPO_Manage)
          ? true
          : false,
      },
      {
        title: "All Change Request",
        icon: "list",
        href: routes?.allChangeRequest?.match,
        subChild: {
          href: [
            // routes?.addTrainingSheetForm?.match,
            routes?.editCR?.matchSidebar,
            routes?.crView?.matchSidebar,
          ],
        },
        display: findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL)
          ? true
          : false,
      },
    ],
  },
  //   {
  //   title: "Tickets",
  //   icon: "book-open",

  //   href: routes?.ticket?.match,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST
  //   )
  //     ? true
  //     : false,

  // },
  // {
  //   title: "Genric Information",
  //   icon: "file-text",
  //   href: "/cr",
  //   collapse: true,
  //   display:
  //     findCurrectPermission(enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS)
  //       ? true
  //       : false,
  //   children: [
  //     {
  //       title: "Hierarchy chart",
  //       icon: "pie-chart",

  //       href: routes?.hierarchy?.match,
  //       display: findCurrectPermission(
  //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //       )
  //         ? true
  //         : false,

  //     },

  //     {
  //       title: "Plant Library",
  //       icon: "book-open",

  //       href: routes?.hierarchy2?.match,
  //       display: findCurrectPermission(
  //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //       )
  //         ? true
  //         : false,

  //     },
  //     {
  //       title: "Plant Layout",
  //       icon: "book-open",

  //       href: routes?.planylayout?.match,
  //       display: findCurrectPermission(
  //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //       )
  //         ? true
  //         : false,

  //     },
  //     {
  //       title: "Recording Request",
  //       icon: "camera",

  //       href: routes?.RecordingRequest?.match,
  //       display: findCurrectPermission(
  //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //       )
  //         ? true
  //         : false,

  //     },
  //     {
  //       title: "Recording List",
  //       icon: "camera",

  //       href: routes?.Recordinglist?.match,
  //       display: findCurrectPermission(
  //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //       )
  //         ? true
  //         : false,

  //     },
  //     {
  //       title: "Monthly Schedule",
  //       icon: "calendar",
  //       href: routes?.monthlySchedule?.match,
  //       display: true,
  //     },
  //     {
  //       title: "Holiday Schedule",
  //       icon: "calendar",
  //       href: routes?.Holiday?.match,
  //       display: true,
  //     },
  //     {
  //       title: "Phonebook",
  //       icon: "phone",
  //       href: routes?.phonebook?.match,
  //       display: true,
  //     },
  //   ],
  // },

  {
    navlabel: true,
    subheader: "APPS",
    icon: "mdi mdi-dots-horizontal",
    href: "Apps",
    display: false,
  },
  {
    title: "Chat",
    icon: "message-square",
    href: "/chats",
    display: false,
  },
  {
    title: "Notes",
    icon: "clipboard",
    href: "/notes",
    display: false,
  },
  {
    title: "Mail",
    icon: "inbox",
    href: "/email",
    display: false,
  },

  {
    title: "Calendar",
    icon: "calendar",
    href: "/calendar",
    display: false,
  },

  {
    title: "Customers",
    icon: "users",
    href: "/customers",
    collapse: true,
    display: false,
    children: [
      {
        title: "Lists",
        icon: "list",
        href: "/customers/lists",
      },
      {
        title: "Edit",
        icon: "edit",
        href: "/customers/edit",
      },
    ],
  },
  {
    navlabel: true,
    subheader: "PAGES",
    icon: "mdi mdi-dots-horizontal",
    href: "Pages",
    display: false,
  },
  {
    title: "Shop",
    icon: "shopping-cart",
    href: "/shop",
    collapse: true,
    display: false,
    children: [
      {
        title: "Listing",
        icon: "list",
        href: "/shop/lists",
      },
      {
        title: "Detail",
        icon: "file-text",
        href: "/shop/shop-detail",
      },
    ],
  },
  {
    title: "Alert",
    icon: "alert-circle",
    href: "/alert",
    display: false,
  },
  {
    title: "User Profile",
    icon: "user",
    href: "/user-profile",
    display: false,
  },
  {
    title: "Quill Editor",
    icon: "edit",
    href: "/quill-editor",
    display: false,
  },
  {
    title: "Treeview",
    icon: "git-pull-request",
    href: "/treeview",
    display: false,
  },
  {
    title: "Pricing",
    icon: "dollar-sign",
    href: "/pricing",
    display: false,
  },
  {
    title: "Typography",
    icon: "type",
    href: "/typography",
    display: false,
  },
  {
    title: "Feather Icons",
    icon: "feather",
    href: "/react-icons",
    display: false,
  },
  {
    title: "Timeline",
    icon: "clock",
    href: "/timeline",
    display: false,
  },
  {
    navlabel: true,
    subheader: "FORMS",
    icon: "mdi mdi-dots-horizontal",
    href: "Form",
    display: false,
  },
  {
    title: "Form Elements",
    icon: "box",
    href: "/form-elements",
    collapse: true,
    display: false,
    children: [
      {
        title: "Autocomplete",
        icon: "compass",
        href: "/form-elements/autocomplete",
      },
      {
        title: "Buttons",
        icon: "codepen",
        href: "/form-elements/button",
      },
      {
        title: "Checkbox",
        icon: "check-square",
        href: "/form-elements/checkbox",
      },
      {
        title: "Radio",
        icon: "check-circle",
        href: "/form-elements/radio",
      },
      {
        title: "Date Time",
        icon: "calendar",
        href: "/form-elements/date-time",
      },
      {
        title: "Slider",
        icon: "git-commit",
        href: "/form-elements/slider",
      },
      {
        title: "Switch",
        icon: "toggle-left",
        href: "/form-elements/switch",
      },
    ],
  },
  {
    title: "Form Layout",
    icon: "file-text",
    href: "/form-layouts/form-layouts",
    display: false,
  },
  {
    title: "Form Custom",
    icon: "file-plus",
    href: "/form-layouts/form-custom",
    display: false,
  },
  {
    title: "Form Wizard",
    icon: "codepen",
    href: "/form-layouts/form-wizard",
    display: false,
  },
  {
    navlabel: true,
    subheader: "TABLES",
    icon: "mdi mdi-dots-horizontal",
    href: "Table",
    display: false,
  },
  {
    title: "Tables",
    icon: "layout",
    href: "/tables",
    collapse: true,
    display: false,
    children: [
      {
        title: "Basic Table",
        icon: "disc",
        href: "/tables/basic-table",
      },
      {
        title: "Pagination Table",
        icon: "disc",
        href: "/tables/pagination-table",
      },
      {
        title: "Enhanced Table",
        icon: "disc",
        href: "/tables/enhanced-table",
      },
      {
        title: "Collapsible Table",
        icon: "disc",
        href: "/tables/collapsible-table",
      },
      {
        title: "Fixed Header Table",
        icon: "disc",
        href: "/tables/fixed-header-table",
      },
    ],
  },
  {
    navlabel: true,
    subheader: "WIDGETS",
    icon: "mdi mdi-dots-horizontal",
    href: "Widgets",
    display: false,
  },
  {
    title: "Widget Feed",
    icon: "archive",
    href: "/widgets/widget-feed",
    display: false,
  },

  {
    title: "Widget Apps",
    icon: "grid",
    href: "/widgets/widget-apps",
    display: false,
  },
  {
    navlabel: true,
    subheader: "CHARTS",
    icon: "mdi mdi-dots-horizontal",
    href: "Chart",
    display: false,
  },
  {
    title: "Line Chart",
    icon: "activity",
    href: "/charts/line-chart",
    display: false,
  },
  {
    title: "Gredient Chart",
    icon: "bar-chart",
    href: "/charts/gredient-chart",
    display: false,
  },
  {
    title: "Doughnut & Pie",
    icon: "bar-chart-2",
    href: "/charts/doughnut-pie-chart",
    display: false,
  },
  {
    title: "Area Chart",
    icon: "aperture",
    href: "/charts/area-chart",
    display: false,
  },
  {
    title: "Column Chart",
    icon: "circle",
    href: "/charts/column-chart",
    display: false,
  },
  {
    title: "Candlestick Chart",
    icon: "loader",
    href: "/charts/candlestick-chart",
    display: false,
  },
  {
    title: "Radialbar & Radar",
    icon: "octagon",
    href: "/charts/radialbar-chart",
    display: false,
  },
  {
    navlabel: true,
    subheader: "AUTHENTICATION",
    icon: "mdi mdi-dots-horizontal",
    href: "Authentication",
    display: false,
  },
  {
    title: "Log in",
    icon: "log-in",
    href: routes?.login?.match,
    display: false,
  },
  {
    title: "Register",
    icon: "user-plus",
    href: routes?.register?.match,
    display: false,
  },
  {
    title: "Reset Password",
    icon: "refresh-ccw",
    href: routes?.resetPassword?.match,
    display: false,
  },
  {
    title: "Error",
    icon: "alert-triangle",
    href: routes?.error?.match,
    display: false,
  },
  {
    navlabel: true,
    subheader: "Admin Panel",
    icon: "mdi mdi-dots-horizontal",
    href: "Website",
    display:
      findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ||
        findCurrectPermission(enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT) ||
        findCurrectPermission(
          enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON
        ) ||
        findCurrectPermission(enums.UserPermissionNames.ROLES_PERMISSIONS)
        ? true
        : false,
  },
  {
    title: "Admin",
    icon: "users",
    href: "/admin",
    collapse: true,
    display:
      findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ||
        findCurrectPermission(enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT) ||
        findCurrectPermission(
          enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON
        ) ||
        findCurrectPermission(enums.UserPermissionNames.ROLES_PERMISSIONS)
        ? true
        : false,
    children: [
      // {
      //   title: "Add Employee",
      //   icon: "list",
      //   href: routes?.addEmployee?.match,
      //   display: findCurrectPermission(
      //     enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE
      //   )
      //     ? true
      //     : false,
      // },
      {
        title: "Employees",
        icon: "list",
        href: routes?.limitEmployee.match,
        subChild: {
          href: [
            routes?.editEmployee?.matchSidebar,
            routes?.employeeView?.matchSidebar,
          ],
        },
        display: findCurrectPermission(
          enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT
        )
          ? true
          : false,
      },
      {
        title: "Approval Document Person",
        icon: "list",
        href: routes?.approvalDocument.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON
        )
          ? true
          : false,
      },
      {
        title: "Role Rights",
        icon: "list",
        href: routes?.roleRights.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.ROLES_PERMISSIONS
        )
          ? true
          : false,
      },
      {
        title: "Master Details",
        icon: "list",
        href: routes?.masterDetails.match,
        display: findCurrectPermission(
          enums.UserPermissionNames.ROLES_PERMISSIONS
        )
          ? true
          : false,
      },
    ],
  },



  // {
  //   navlabel: true,
  //   subheader: "GENRIC INFORMATION",
  //   icon: "mdi mdi-dots-horizontal",
  //   href: "Website",
  //   display:
  //     findCurrectPermission(enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS)

  //       ? true
  //       : false,
  // },
  // {
  //   title: "Hierarchy chart",
  //   icon: "pie-chart",

  //   href: routes?.hierarchy?.match,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //   )
  //     ? true
  //     : false,

  // },

  // {
  //   title: "Plant Library",
  //   icon: "book-open",

  //   href: routes?.hierarchy2?.match,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //   )
  //     ? true
  //     : false,

  // },
  // {
  //   title: "Plant Layout",
  //   icon: "book-open",

  //   href: routes?.planylayout?.match,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //   )
  //     ? true
  //     : false,

  // },
  // {
  //   title: "Recording Request",
  //   icon: "camera",

  //   href:routes?.RecordingRequest?.match,
  // display: findCurrectPermission(
  //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //       )
  //         ? true
  //         : false,

  // },
  // {
  //   title: "Recording List",
  //   icon: "camera",

  //   href: routes?.Recordinglist?.match,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //   )
  //     ? true
  //     : false,

  // },
  // {
  //   title: "Monthly Schedule",
  //   icon: "calendar",
  //   href: routes?.monthlySchedule?.match,
  //   display: true,
  // },
  // {
  //   title: "Holiday Schedule",
  //   icon: "calendar",
  //   href: routes?.Holiday?.match,
  //   display: true,
  // },
  // {
  //   title: "Phonebook",
  //   icon: "phone",
  //   href: routes?.phonebook?.match,
  //   display: true,
  // },
  {
    navlabel: true,
    subheader: "Departmental Applications",
    icon: "mdi mdi-dots-horizontal",
    href: "Departmental Applications",
    display: true,
    // findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ||
    // findCurrectPermission(enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT) ||
    // findCurrectPermission(
    //   enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON
    // )|| findCurrectPermission(
    //       enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS        ) ||
    // findCurrectPermission(enums.UserPermissionNames.ROLES_PERMISSIONS)
    //   ? true
    //   : false,
  },
  // {
  //   title: "META",
  //   icon: "list",
  //   href: `http://localhost:3000/login?username=${UserName?.name}`,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST
  //   )
  //     ? true
  //     : false,

  // },
  // {
  //   title: "Conference Booking",
  //   icon: "users",
  //   href: `https://conferencebooking.sswhite.co/`,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST
  //   )
  //     ? true
  //     : false,

  // },
  //    {
  //   title: "Gatepass",
  //   icon: "list",    
  //   href: `http://localhost:3000/login?username=${UserName?.name}`,
  //   display: findCurrectPermission(
  //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
  //       )
  //         ? true
  //         : false,

  // },
  // {
  //   title: "Gate Pass",
  //   icon: "list",
  //   href: `https://gatepass.sswhite.co?userloginID=${localStorage.getItem("encryptedUserId")}`,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST
  //   )
  //     ? true
  //     : false,
  // },
  {
    title: "Gate Pass",
    icon: "list",
    href: `https://gatepassnew.sswhite.co/login?username=${UserName?.name}`,
    display: true,
  },
  {
    title: "TPM - Total Procure Master",
    icon: "list",
    href: `https://tpm.sswhite.co/login?username=${encodeURIComponent(UserName?.name)}&password=${btoa(UserName?.password)}`,
    display: true,
  },
  {
    title: "EDIOT",
    icon: "list",
    href: `https://ediot.sswhite.co/login?username=${UserName?.name}`,
    display: true,
  },
  {
    title: "META",
    icon: "list",
    href: `https://metanew.sswhite.co/login?username=${UserName?.name}`,
    display: true,
  },

  {
    title: "Conference Booking",
    icon: "users",
    href: `https://conferencebooking.sswhite.co/`,
    display: true,
  },
  {
    navlabel: true,
    subheader: "Security Screen",
    icon: "mdi mdi-dots-horizontal",
    href: "Security Screen",
    display: findCurrectPermission(
      enums.UserPermissionNames.SECURITY_SCREEN
    )
      ? true
      : false,
  },
  {
    title: "Visitor Pass Display",
    icon: "list",
    href: routes?.VisitorDisplay.match,
    display: findCurrectPermission(
      enums.UserPermissionNames.SECURITY_SCREEN
    )
      ? true
      : false,
  },
  {
    title: "Material Pass Display",
    icon: "list",
    href: routes?.MaterialPassDisplay.match,
    display: findCurrectPermission(
      enums.UserPermissionNames.SECURITY_SCREEN
    )
      ? true
      : false,
  },

  // {
  //   title: "Add Employee",
  //   icon: "list",
  //   href: routes?.addEmployee?.match,
  //   display: findCurrectPermission(
  //     enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE
  //   )
  //     ? true
  //     : false,
  // },

];

export default Menuitems;
